function loadView(view) {
  return () => import(/* webpackChunkName: "view-[request]" */ `@/components/${view}.vue`)
}

// Dvisiones
export default [
  {
    path: 'users/notifications',
    name: 'UsersBackNotifications',
    component: loadView('Back/User/Notifications')
  },
  {
    path: 'users/invitations',
    name: 'UsersBackInvitations',
    component: loadView('Back/User/Invitations')
  },
  {
    path: 'users/messages',
    name: 'UsersBackMessages',
    component: loadView('Back/User/Messages')
  },
  {
    path: 'users/favourites/teams',
    name: 'UsersBackFavouriteTeams',
    component: loadView('Back/User/FavouriteTeams')
  },
  {
    path: 'users/favourites/tournaments',
    name: 'UsersBackFavouriteTournaments',
    component: loadView('Back/User/FavouriteTournaments')
  },
  {
    path: 'users/favourites/friends',
    name: 'UsersBackFavouriteFriends',
    component: loadView('Back/User/Friends')
  }
]
